import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../AuthContext";
import { useTranslation } from "react-i18next";

import "./styles/LogIn.css";

import tireBannerDown from "../medias/png/icons/tire_banner_down.png";
import tireBannerUp from "../medias/png/icons/tire_banner_up.png";

const LogIn = () => {
  const { t } = useTranslation();

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [passwordVisible, setPasswordVisible] = useState(false);

  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_API_URL;
  const { user, LogIn } = useAuth();

  useEffect(() => {
    if (user) {
      navigate("/profil");
    }
  }, [user, navigate]);

  const togglePasswordVisibility = () => {
    setPasswordVisible((v) => !v);
  };

  const handleEmailChange = (event) => setEmail(event.target.value);
  const handlePasswordChange = (event) => setPassword(event.target.value);

  const handleSubmit = async (event) => {
    event.preventDefault();

    const emailRegex = /^[\w-.]+@([\w-]+.)+[\w-]{2,4}$/;
    if (!emailRegex.test(email)) {
      alert(t("login.errors.invalidEmail"));
      return;
    }

    const userData = { email, password };

    try {
      const response = await fetch(`${apiUrl}/log-in`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
        credentials: "include",
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || t("login.errors.failed"));
      }

      const userId = data.userId;
      const accountType = data.accountType;
      LogIn(userId, accountType);

      navigate("/profil");
    } catch (error) {
      console.error("Erreur lors de la connexion:", error);
      alert(error.message);
    }
  };

  return (
    <main className="login">
      <h1>{t("login.title")}</h1>

      <img
        src={tireBannerDown}
        alt={t("login.alt.tireBannerDown")}
        className="login-left-banner"
        width="606"
        height="714"
      />
      <img
        src={tireBannerUp}
        alt={t("login.alt.tireBannerUp")}
        className="login-right-banner"
        width="526"
        height="707"
      />

      <form onSubmit={handleSubmit} className="login-form">
        <div className="login-form-control">
          <label htmlFor="email">{t("login.form.email")}</label>
          <img
            src={`${process.env.PUBLIC_URL}/icons/user.png`}
            alt={t("login.alt.userIcon")}
            className="login-icon"
            width="24"
            height="24"
          />
          <input
            id="email"
            type="email"
            value={email}
            onChange={handleEmailChange}
            required
          />
        </div>

        <div className="login-form-control">
          <label htmlFor="password">{t("login.form.password")}</label>
          <img
            src={`${process.env.PUBLIC_URL}/icons/lock.png`}
            alt={t("login.alt.lockIcon")}
            className="login-icon"
            width="24"
            height="24"
          />
          <input
            id="password"
            type={passwordVisible ? "text" : "password"}
            value={password}
            onChange={handlePasswordChange}
            required
          />
          <img
            src={`${process.env.PUBLIC_URL}/icons/eye.png`}
            alt={t("login.alt.eyeIcon")}
            className="login-form-visibility-icon"
            width="20"
            height="20"
            onClick={togglePasswordVisibility}
            role="button"
            tabIndex={0}
          />
        </div>

        <div className="login-form-options">
          <label className="login-remember-me">
            <input type="checkbox" name="remember" />
            {t("login.form.rememberMe")}
          </label>

          <a href="/ask-reset-password" className="login-forgot-password">
            {t("login.links.forgotPassword")}
          </a>
        </div>

        <div className="login-button-container">
          <button type="submit" className="login-button">
            {t("login.form.submit")}
          </button>
        </div>
      </form>

      <a href="/signup" className="login-forgot-password">
        {t("login.links.noAccount")}
      </a>
    </main>
  );
};

export default LogIn;
